import { IDecisionOrganization } from 'APIPackage/DecisionModule/interfaces/IDecisionOrganization';
import { ITargetEntity } from 'APIPackage/DictionariesModule/interfaces/ITargetEntity';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IKnmDistrictSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmDistrictSelectOption';

import { convertDecisionResultFormValuesToData } from './convertDecisionResultFormValuesToData';
import { IDecisionOrganizationForm } from '../interfaces/IDecisionOrganizationForm';
import { convertDecisionActFormValuesToData } from './convertDecisionActFormValuesToData';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export const convertDecisionOrganizationFormValuesToDecisionData = (
  organization?: IDecisionOrganizationForm,
  isOrganizationNew?: boolean,
  isDraft?: boolean,
): IDecisionOrganization | null => {
  if (!organization) {
    return null;
  }

  const {
    guid,
    inn,
    ogrn,
    checkSubjectResult,
    country,
    document,
    epguNotifications,
    ervkId,
    factualAddress,
    isAutocomplete,
    isForeignSubjectAgencyNotRegisteredInRf,
    isSonko,
    kpp,
    mspCode,
    nkoForeignAgentsRegistryExclusionDate,
    nkoForeignAgentsRegistryInclusionDate,
    nkoForeignAgentsRegistryNumber,
    organizationType,
    originalName,
    originalNameReactQuillEditor,
    rafpNza,
    smevRequestStatus,
    snils,
    workAddress,
    isPresentInItRegistry,
    itAccreditationResponse,
    smevItAccreditationRequestStatus,
    resultDecisions,
    act,
    locationRegionCodeFromFns,
    locationAddress,
    locationnotInFIAS: isLocationNotInFIAS,
    locationmanualAddress,
  } = organization;
  const getAddressFields = (prefix: 'location' | 'work' | 'factual') => {
    const isNotInFIAS = organization[`${prefix}notInFIAS` as keyof IDecisionOrganizationForm] as boolean | undefined;

    const address = organization[`${prefix}Address` as keyof IDecisionOrganizationForm] as string | undefined;
    const region = organization[`${prefix}region` as keyof IDecisionOrganizationForm] as
      | IKnmDistrictSelectOption
      | undefined;
    const regionName = organization[`${prefix}RegionName` as keyof IDecisionOrganizationForm] as string | undefined;
    const manualAddress = organization[`${prefix}manualAddress` as keyof IDecisionOrganizationForm] as
      | string
      | undefined;
    const fiasRegion = organization[`${prefix}fiasRegion` as keyof IDecisionOrganizationForm] as
      | IKnmDistrictSelectOption
      | undefined;

    if (isNotInFIAS && !organization.ervkId) {
      // Передаем id региона вместо названия
      const regionId = (region && typeof region === 'object' && 'id' in region ? region.id.toString() : null) || null;
      const locationregionId =
        (region && typeof region === 'object' && 'id' in region ? region.id.toString() : null) || null;

      // Когда notInFIAS = true, address должен быть null, адрес хранится в manualAddress и region
      return {
        address: null,
        region: regionId || locationregionId || null,
        regionName: regionName || null,
        manualAddress: manualAddress || null,
        notInFIAS: true,
        fiasRegion: null,
      };
    }
    // Когда notInFIAS = false, получаем fiasRegion
    const fiasRegionId =
      (fiasRegion && typeof fiasRegion === 'object' && 'id' in fiasRegion ? fiasRegion.id.toString() : null) || null;

    return {
      address: address || null,
      region: null,
      regionName: null,
      manualAddress: null,
      isNotInFIAS,
      fiasRegion: fiasRegionId,
    };
  };

  const locationFields = getAddressFields('location');

  return {
    isNew: isDraft ? !!isOrganizationNew : null,
    guid: guid || null,
    name: originalName || null,
    inn: inn || null,
    ogrn: ogrn || null,
    mspCode: mspCode || null,
    checkSubjectResult: checkSubjectResult || null,
    isAutocomplete: typeof isAutocomplete === 'boolean' ? isAutocomplete : null,
    nkoForeignAgentsRegistryNumber: nkoForeignAgentsRegistryNumber || null,
    nkoForeignAgentsRegistryInclusionDate: nkoForeignAgentsRegistryInclusionDate || null,
    nkoForeignAgentsRegistryExclusionDate: nkoForeignAgentsRegistryExclusionDate || null,
    isNko: !!nkoForeignAgentsRegistryInclusionDate,
    organizationType: organizationType
      ? ({ code: organizationType.code, title: organizationType.title } as IDictionarySelectOption<ITargetEntity>)
      : null,
    kpp: kpp || null,
    smevRequestStatus: smevRequestStatus || null,
    rafpNza: rafpNza || null,
    isForeignSubjectAgencyNotRegisteredInRf:
      typeof isForeignSubjectAgencyNotRegisteredInRf === 'boolean' ? isForeignSubjectAgencyNotRegisteredInRf : null,
    country: country || null,
    isSonko: typeof isSonko === 'boolean' ? isSonko : null,
    locationAddress: locationFields.address || locationAddress || null,
    workAddress: workAddress || null,
    factualAddress: factualAddress || null,
    snils: snils || null,
    document: document || null,
    ervkId: ervkId || null,
    originalName: originalName || null,
    originalNameReactQuillEditor: originalNameReactQuillEditor
      ? handleReactQuillDeltaValue(originalNameReactQuillEditor || originalName)
      : null,
    epguNotifications: epguNotifications || null,
    act: act ? convertDecisionActFormValuesToData(act, isDraft) : null,

    decisions: resultDecisions?.map(item => convertDecisionResultFormValuesToData(item, isDraft)) ?? null,
    isPresentInItRegistry: isPresentInItRegistry ?? null,
    itAccreditationResponse: itAccreditationResponse ?? null,
    smevItAccreditationRequestStatus: smevItAccreditationRequestStatus ?? null,
    locationRegion: locationFields.region || null,
    locationNotInFIAS: locationFields.isNotInFIAS || isLocationNotInFIAS || null,
    locationManualAddress: locationFields.manualAddress || locationmanualAddress || null,
    locationFiasRegion: locationFields.fiasRegion || null,
    locationRegionCodeFromFns: locationRegionCodeFromFns ?? null,
  };
};
